import React from 'react';
import styled from 'styled-components';
import TooltipDialog from '@ntuctech/devex-tangram/Tooltip/TooltipDialog';
import SvgInfo from '@ntuctech/devex-tangram/Icon/SvgInfo';
import { LINKS } from '../../../constants';

const FooterLogoSC = styled.div`
  display: inline-flex;
  align-items: center;

  .SSONEDLogo__help {
    cursor: pointer;
  }

  .SSONED_learn-more {
    visibility: hidden;
    width: 0px;
    height: 0px;
  }
`;
const LogoImageSC = styled.img`
  margin: 1.5rem 0.2rem 1.5rem 0;
  width: 8.75rem;

  @media (max-width: ${(props) => `${parseInt(props.theme.SizeBreakpointsS, 10) - 1}px`}) {
    margin: 1rem 0;
  }
`;

export default function FooterLogo() {
  const [openTooltip, setOpenTooltip] = React.useState(false);
  const learnMoreLink = React.useRef(null);
  const tooltipTitle = 'What is NE Digital?';
  const tooltipContent =
    'NE Digital is the digital, data and technology organization that drives the Digital Transformation for NTUC Social Enterprises.';
  const actions = ['Read More'];

  const onReadMore = () => {
    learnMoreLink.current.click();
    setOpenTooltip(false);
  };
  const onClose = () => {
    setOpenTooltip(false);
  };
  const onOpen = () => {
    setOpenTooltip(true);
  };
  return (
    <FooterLogoSC>
      <LogoImageSC
        src="https://media.nedigital.sg/nedigital/files/7d7a115c-93da-43ff-b458-5e3af03095d2/powered-by-nedigital.svg"
        alt="Powered by NE Digital"
      />
      <a
        href={LINKS.LEARN_MORE}
        target="_blank"
        rel="noopener noreferrer"
        className="SSONED_learn-more"
        title="NE Digital Read More"
        ref={learnMoreLink}
      >
        Read More
      </a>
      <div className="SSONEDLogo__help">
        <TooltipDialog
          title={tooltipTitle}
          content={tooltipContent}
          placement="top-end"
          actions={actions}
          onActions={[onReadMore]}
          open={openTooltip}
          onClose={onClose}
          onOpen={onOpen}
          trigger="click"
        >
          {/* for IE11 */}
          {/* do not remove <div> */}
          {/* because Node.contains() method */}
          {/* is not supported by IE11 on SVGElements */}
          {/* it will cause console error */}
          {/* on every user click */}
          <div>
            <SvgInfo size="s" color="#FFFFFF" className="SSONEDLogo__help-icon" />
          </div>
        </TooltipDialog>
      </div>
    </FooterLogoSC>
  );
}
